import { EuiCollapsibleNavBeta } from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { memo } from "react";
import { ProjectHeaderNavProps } from "./ProjectHeaderNav";
import { TenantType } from "types/constants";

type ProjectHeaderNavSpaceProps = Pick<
  ProjectHeaderNavProps,
  "currentTenant" | "isCurrentUsersPersonalSpace"
>;

export const HeaderNavSpace = memo(function HeaderNavSpace({
  currentTenant,
  isCurrentUsersPersonalSpace,
}: ProjectHeaderNavSpaceProps) {
  const routeMap = useRouteMapContext((s) => s.routeMap);
  return (
    <EuiCollapsibleNavBeta.Item
      title={
        isCurrentUsersPersonalSpace ? "Personal Space" : currentTenant.name
      }
      icon={
        currentTenant.tenantType === TenantType.PERSONAL ? "spacesApp" : "users"
      }
      onClick={() => {
        routeMap.ORGANIZATION.dynamicPath({
          tenantKey: currentTenant.key,
        }).navigateTo();
      }}
    />
  );
});
